module.exports = __webpack_public_path__ + "assets/img/third_right_arrow.874a396c.png";